import { createAsyncThunk } from '@reduxjs/toolkit';
import cycleCountApi from '../../../api/cycleCountApi';
import factoryOptionsApi from '../../../api/factoryOptionsApi';
import tobaccoProductionsApi from '../../../api/tobaccoProductionsApi';

// ---------------------------------------------------------------------

const REDUCER_NAME = 'cycleCounts';

export const CreateCycleCount = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/createCycleCount`,
  async (data, thunkAPI) => {
    const res = await cycleCountApi.create(data);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetCycleCounts = createAsyncThunk<any, any>(`${REDUCER_NAME}/getCycleCounts`, async (filter, thunkAPI) => {
  const res = await cycleCountApi.get(filter);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const GetCycleCountNumbers = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getCycleCountNumbers`,
  async (thunkAPI) => {
    const res = await cycleCountApi.getForSchedulerTasks();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetCycleCountResult = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/getCycleCountResult`,
  async (cycleCountRequestId, thunkAPI) => {
    const res = await cycleCountApi.getResult(cycleCountRequestId);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetPendingCycleCountRequests = createAsyncThunk(
  `${REDUCER_NAME}/getPendingCycleCountRequests`,
  async (__, thunkAPI) => {
    const res = await cycleCountApi.getPendingCycleCountRequests();

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetCycleCountById = createAsyncThunk<any, string>(
  `${REDUCER_NAME}/getCycleCountById`,
  async (id, thunkAPI) => {
    const res = await cycleCountApi.getById(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateCycleCount = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateCycleCount`,
  async ({ data, id }, thunkAPI) => {
    const res = await cycleCountApi.update(data, id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ChangeCycleCountStatus = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/changeCycleCount`,
  async ({ data, id }, thunkAPI) => {
    const res = await cycleCountApi.changeStatus(data, id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const ApplyActualQuantity = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/applyActualQuantity`,
  async ({ id }, thunkAPI) => {
    const res = await cycleCountApi.applyActualQuantity(id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const BatchApplyActualQuantity = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/batchApplyActualQuantity`,
  async ({ ids }, thunkAPI) => {
    const res = await cycleCountApi.batchApplyActualQuantity(ids);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const UpdateCycleCountResult = createAsyncThunk<any, any>(
  `${REDUCER_NAME}/updateCycleCountResult`,
  async ({ data, id }, thunkAPI) => {
    const res = await cycleCountApi.updateResult(data, id);

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const RepeatRequest = createAsyncThunk<any, any>(`${REDUCER_NAME}/repeatRequest`, async (id, thunkAPI) => {
  const res = await cycleCountApi.repeatRequest(id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const ResetRequest = createAsyncThunk<any, any>(`${REDUCER_NAME}/resetRequest`, async (id, thunkAPI) => {
  const res = await cycleCountApi.resetRequest(id);

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});

export const FactoryOptionsTobaccoTypes = createAsyncThunk(
  `${REDUCER_NAME}/factoryOptionsTypes`,
  async (__, thunkAPI) => {
    const res = await factoryOptionsApi.getByName('tobaccoTypes');

    if (res.status === 200) {
      return res.data;
    }

    return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
  }
);

export const GetConveyorSteps = createAsyncThunk(`${REDUCER_NAME}/getConveyorSteps`, async (__, thunkAPI) => {
  const res = await tobaccoProductionsApi.getTobaccoConveyorSteps();

  if (res.status === 200) {
    return res.data;
  }

  return thunkAPI.rejectWithValue({ status: 'error', message: 'Fetch failed' });
});
